import { useCallback, useState } from "react";
import { useMap, useMapEvent } from "react-leaflet";

export function useMapZoom(): number {
  const map = useMap();
  const [zoom, setZoom] = useState(() => map.getZoom());

  const handleZoomEnd = useCallback(() => setZoom(map.getZoom()), [map]);
  useMapEvent("zoomend", handleZoomEnd);

  return zoom;
}
